import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import mapLoyaltyAccount from 'api/mappers/loyalty/mapLoyaltyAccount'
import requestUtils, { authOptions } from 'api/requestUtils'

type Payload = paths['/api/lux-loyalty/account']['post']['parameters']['body']['payload']
type Response = paths['/api/lux-loyalty/account']['post']['responses']['201']['content']['application/json']

async function requestLoyaltyAccountEnrolment(payload: Payload, token?: string) {
  const response = await requestUtils.post<Response, Payload>(
    '/api/lux-loyalty/account',
    payload,
    {
      ...authOptions(token),
      excludeBrand: true,
    })

  return mapLoyaltyAccount(response.result.accountSummary)
}

export default requestLoyaltyAccountEnrolment
